import React from "react";
import SupportPageLayout from "../components/layout/SupportPageLayout";

const SizingHelpPage = () => {
  return (
    <SupportPageLayout
      title="Sizing Help"
      description="Sizing guidance reduces uncertainty and supports better conversion for wearable items like scrub sets."
      path="/sizing-help"
    >
      <section>
        <h2 className="text-2xl font-light text-white">Before ordering</h2>
        <p className="mt-3 leading-relaxed text-gray-300">
          Compare your usual fit with the product details shown on the item
          page. If you are choosing scrub sets for workwear, consider the fit
          you prefer during long shifts and layering.
        </p>
      </section>
      <section>
        <h2 className="text-2xl font-light text-white">Need product-specific guidance?</h2>
        <p className="mt-3 leading-relaxed text-gray-300">
          Contact us before purchase with the product name and your usual size,
          and we can help you choose more confidently.
        </p>
      </section>
      <section>
        <h2 className="text-2xl font-light text-white">Contact support</h2>
        <p className="mt-3 leading-relaxed text-gray-300">
          Reach us at{" "}
          <a className="text-amber-300 hover:text-amber-200" href="mailto:hello@jmolux.com">
            hello@jmolux.com
          </a>{" "}
          for sizing recommendations.
        </p>
      </section>
    </SupportPageLayout>
  );
};

export default SizingHelpPage;
